import { isEmail, isPhoneNumber } from '@onefootprint/core';
import type { VaultData } from '@onefootprint/request-types';

export type ValidatedIdentifyBootstrap = {
  data: Partial<VaultData>;
  bootstrapEmail?: string;
  bootstrapPhone?: string;
  isBootstrap: boolean;
};

const validateString = (value: unknown, validator: (v: string) => boolean): string | undefined =>
  typeof value === 'string' && validator(value) ? value : undefined;

/**
 * Validates id.email and id.phone_number from bootstrap data for identify session creation.
 * Returns sanitized data and prefill values for email/phone routes.
 */
export function getValidatedIdentifyBootstrap(kycBootstrapData?: VaultData): ValidatedIdentifyBootstrap {
  const bootstrapEmail = validateString(kycBootstrapData?.['id.email'], isEmail);
  const bootstrapPhone = validateString(kycBootstrapData?.['id.phone_number'], isPhoneNumber);

  const data: Partial<VaultData> = {
    ...(bootstrapEmail && { 'id.email': bootstrapEmail }),
    ...(bootstrapPhone && { 'id.phone_number': bootstrapPhone }),
  };

  return {
    data,
    bootstrapEmail,
    bootstrapPhone,
    isBootstrap: bootstrapEmail != null || bootstrapPhone != null,
  };
}
